import { D as e } from "./index-cR_FevlS.mjs";
import "react";
import "@cw-elements/config";
import "@cw-elements/mfe-dynamic-slot";
import "react-dom";
export {
  e as DeckOfApps
};
